import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-tenant',
  templateUrl: './select-tenant.component.html',
  styleUrls: ['./select-tenant.component.css']
})
export class SelectTenantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
